const Header = () => {

    const header_element = document.querySelector('.header');
    const mobile_menu = document.querySelector('.mobile-menu');
    const scrolled_class = 'header--scrolled';
    const mobile_class = 'mobile-menu--scrolled';
    const body_tag = document.querySelector('body');

    window.addEventListener('scroll', () => {
        
        const current_scroll = window.pageYOffset;

        if (current_scroll > 0) {
            header_element.classList.add(scrolled_class);
            mobile_menu.classList.add(mobile_class);
        } else {
            header_element.classList.remove(scrolled_class);
            mobile_menu.classList.remove(mobile_class);
        }

        // headerOffset();
    });

    // headerOffset();
    // window.addEventListener('resize', headerOffset);

    function headerOffset() {
        
        let offset = document.querySelector('.header').offsetHeight;

        if ( offset ) {
            body_tag.style.paddingTop = `${offset}px`;
        }
    }
}

export default Header;